<template>
  <div>
    <div class="export1">
      <div class="export2">
        <div>请选择设备：</div>
        <Select v-model="query.macIds" multiple style="width:300px" max-tag-count='2' filterable='true'>
          <Option v-for="item in macIds" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="export2" style="margin-left:20px">
        <div>请选择时间：</div>
				<div class="export2">
					<DatePicker type="datetime" placeholder="开始时间" v-model='kaishi' style="width: 200px" @on-change="onchangeKaishi" @on-ok="onok"></DatePicker>
					<div>--</div>
					<DatePicker type="datetime" placeholder="结束时间" v-model='jieshu' style="width: 200px" @on-change="onchangeJieshu" @on-ok="onok"></DatePicker>
				</div>
      </div>
      <Button type="info" style="margin-left:20px" @click="daochu">导出</Button>
    </div>
  </div>
</template>

<script>
  import http from '@/http/http.js'
  export default {
    data(){
      return{
        kaishi:'',
        jieshu:'',
        macIds:[],
        query:{
          macIds:[],
          startTime:'',
          endTime:''
        },
        num:0,
        begin1:'',
        end1:'',
        time:''
      }
    },
    created(){
      this.quarySB()
    },
    methods:{
      daochu(){
        if(this.query.macIds == '') {
          this.$Message.info('请选择设备')
          return false;
        }
        if(this.query.startTime == '') {
          this.$Message.info('请选择开始时间')
          return false;
        }
        if(this.query.endTime == '') {
          this.$Message.info('请选择结束时间')
          return false;
        }
        if(this.num>12) {
          this.$Message.info('相差时间不能大于12个月')
          return false;
        }
        if(this.begin1>this.end1) {
          this.$Message.info('开始时间不能大于结束时间')
          return false;
        }
        this.quaryAjax()
      },
      onchangeKaishi(time){
        this.query.startTime = time
      },
      onchangeJieshu(time){
        this.query.endTime = time
      },
      onok(){
        let begin = this.query.startTime.substring(0,10)
        let end = this.query.endTime.substring(0,10)
        begin = begin.split('-')
        begin = parseInt(begin[0]) * 12 + parseInt(begin[1])
        end = end.split('-')
        end = parseInt(end[0]) * 12 + parseInt(end[1])
        this.num = Math.abs(end-begin)
        this.begin1 = new Date(this.query.startTime).getTime()
        this.end1 = new Date(this.query.endTime).getTime()
        if(this.begin1>this.end1) {
          this.$Message.info('开始时间不能大于结束时间')
          return false;
        }
        if(this.num>12) {
          this.$Message.info('相差时间不能大于12个月')
          return false;
        }
      },
      quaryAjax(){
        http.http({
          method: 'post',
          url: http.url + '/fin/report/comm/sales/salesData',
          data: this.query,
					success: (res)=> {
            if(res.code == 200) {
              let totalData = res.list
              require.ensure([],()=>{
                const {export_json_to_excel}=require('../../../../../excel/Export2Excel.js')
                const tHeader = ['商品名称','设备ID','设备名称','数量','退款价格','销售总价','进价',]
                const filterVal = ['goodsName','macId','macName','num','retreatPrice','totalPrice','enterPrice']
                let listfix = []
                res.list.forEach((item,index)=>{
                    let obj={
                      'goodsName':item.goodsName,
                      'macId':item.macId,
                      'macName':item.macName,
                      'num':item.num,
                      'retreatPrice':item.retreatPrice,
                      'totalPrice':item.totalPrice,
                      'enterPrice':item.enterPrice,
                    }
                    listfix.push(obj)
                })
                const list =[...listfix]
                const data = this.formatJson(filterVal,list)
                export_json_to_excel(tHeader,data,'销售数据')
              })
            }
					}
				})
      },
      formatJson(filterVal, jsonData) { //这里必须写
          return jsonData.map(v => filterVal.map(j => v[j]))
      },
      quarySB(){
        http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/oper',
				    data: {page:0,size:1000},
					  success: (data)=> {
              let items = data.macFaultDetailss.content
              for (let i = 0; i < items.length; i++) {
                let a={
                  value: '',
                  label: ''
                }
                a.value=items[i].id
                a.label=items[i].id+"-"+items[i].address
                this.macIds.push(a)
              }
            }
				  })
      }
    }
  }
</script>

<style lang="less" scoped>
.export1{
  width: 100%;
  display: flex;
  align-items: center;
  .export2{
    display: flex;
    align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/oper/finance/daochu/exportsalesreport.vue